import { EMarkAsReadNotificationActionTypes, TMarkAsReadNotificationLoading } from './types';
import { actionGenerator } from '../../../utils/redux/actionGenerator';

export const markAsReadLoading: () => TMarkAsReadNotificationLoading =
  actionGenerator<EMarkAsReadNotificationActionTypes.Loading>(EMarkAsReadNotificationActionTypes.Loading);
